export default __webpack_public_path__ + "static/media/53-Point-of-Use-Panels.3f375272.jpg";